import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreadcrumbService } from 'src/app/breadcrumb.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-surety',
    templateUrl: './surety.component.html',
    styleUrls: ['./surety.component.css'],
})
export class SuretyComponent implements OnInit {
    readonly urlPrecalificaNatural = environment.URL_SURETY_PREQUALIFY_NATURAL;
    readonly urlPrecalificaJuridica = environment.URL_SURETY_PREQUALIFY_JURIDICA;
    readonly urlCalificacionNatural =
        environment.URL_SURETY_QUALIFICATION_NATURAL;
    readonly urlCalificacionJuridica =
        environment.URL_SURETY_QUALIFICATION_JURIDICA;
    readonly urlOportunidadNatural = environment.URL_SURETY_OPPORTUNITY_NATURAL;
    readonly urlOportunidadJuridica = environment.URL_SURETY_OPPORTUNITY_JURIDICA;

    constructor(
        private breadcrumbService: BreadcrumbService,
        private router: Router
    ) {
        const sessionData = JSON.parse(
            sessionStorage.getItem('access_token') || '{}'
        );
        if (!sessionData || !sessionData.user || !sessionData.user.brokerId) {
            this.router.navigate(['/home']);
            return;
        }
    }

    ngOnInit(): void {
        this.cargarBreadCrum();
    }

    cargarBreadCrum() {
        this.breadcrumbService.setItems([
            { label: 'Inicio', routerLink: ['/home'] },
            { label: 'Seguro de Fianzas', routerLink: ['/surety'] },
        ]);
    }

    openLink(url: string): void {
        window.open(url, '_blank');
    }
}
